import theme from '../../../../../lib/theme';
import { SpacerBlockProps } from './SpacerBlock';

const {
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

const getScale = (gutter: string): string => {
  switch (gutter) {
    case 'none':
      return '0';
    case 'xxs':
      return scale.xxs;
    case 'xs':
      return scale.xs;
    case 's':
      return scale.s;
    case 'm':
      return scale.m;
    case 'l':
      return scale.l;
    case 'xl':
      return scale.xl;
    case 'xxl':
      return scale.xxl;
    default:
      return '0';
  }
}

export default ({ block: { desktop_spacing, mobile_spacing } }: SpacerBlockProps) => ({
  container: {
		marginTop: '0!important',
		marginBottom: '0!important',
    padding: `calc(${getScale(mobile_spacing)} / 2) 0 calc(${getScale(mobile_spacing)} / 2) 0`,

    [media.s.up]: {
      padding: `calc(${getScale(desktop_spacing)} / 2) 0 calc(${getScale(desktop_spacing)} / 2) 0`,
    }
  },
});